import * as v from 'valibot';
import { create } from 'zustand';
import type { BTCalculatorState } from '../types';
import { calculateFormResults } from '../utils';
import { btCalculatorFormSchema } from './schema';

const defaultFormValues: BTCalculatorState['form'] = {
  debt: '10000',
  interestRate: '24',
  balanceTransferFee: 0.03,
  zeroInterestPeriod: '18',
};

const defaultResults = calculateFormResults({
  ...defaultFormValues,
  debt: Number(defaultFormValues.debt),
  interestRate: Number(defaultFormValues.interestRate),
  zeroInterestPeriod: Number(defaultFormValues.zeroInterestPeriod),
});

export const useBTCalculatorStore = create<BTCalculatorState>((set, get) => ({
  form: defaultFormValues,
  results: defaultResults,
  errors: {},
  setField: (field, value) =>
    set(state => ({
      form: { ...state.form, [field]: value },
      errors: { ...state.errors, [field]: undefined }, // Clear error on change
    })),
  validate: (form: BTCalculatorState['form']) => {
    const result = v.safeParse(btCalculatorFormSchema, form);
    if (!result.success) {
      const errors = Object.fromEntries(
        result.issues.map(issue => {
          if (issue?.path?.[0].key) {
            return [issue.path[0].key, issue.message];
          }
          return [];
        }),
      );
      set({ errors });
      return false;
    }
    set({ errors: {} });
    return result.output;
  },
  calculate: () => {
    const { form, validate } = get();
    const validationResult = validate(form);
    if (validationResult) {
      const results = calculateFormResults(validationResult);
      set({ results });
      return true;
    }
    return false;
  },
}));
